module.exports = __webpack_public_path__ + "img/usernoavatar.f16e6ee4.png";